export const MapLegendIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 5.30488C1 4.13835 1 3.55508 1.30537 3.21489C1.41379 3.09411 1.54556 2.99744 1.69241 2.93094C2.10604 2.74363 2.64965 2.92808 3.73687 3.29697C4.56691 3.5786 4.98193 3.71941 5.4013 3.70484C5.55532 3.69948 5.70843 3.67861 5.85841 3.64253C6.26677 3.54427 6.63076 3.29726 7.35876 2.80325L8.43389 2.07368C9.36642 1.44087 9.83268 1.12446 10.3679 1.05151C10.9031 0.978547 11.4348 1.15893 12.498 1.51968L13.4039 1.82705C14.1739 2.0883 14.5589 2.21893 14.7791 2.52991C14.9993 2.8409 14.9993 3.25397 14.9993 4.08013V10.515C14.9993 11.6815 14.9993 12.2648 14.6939 12.6049C14.5855 12.7257 14.4537 12.8224 14.3069 12.8889C13.8932 13.0762 13.3496 12.8918 12.2624 12.5229C11.4324 12.2412 11.0173 12.1004 10.598 12.115C10.444 12.1204 10.2908 12.1412 10.1409 12.1773C9.73251 12.2756 9.36851 12.5226 8.64052 13.0166L7.56539 13.7462C6.63286 14.379 6.1666 14.6954 5.63137 14.7683C5.09614 14.8413 4.56452 14.6609 3.50127 14.3002L2.59539 13.9928C1.8254 13.7315 1.44041 13.6009 1.22021 13.2899C1 12.9789 1 12.5659 1 11.7397V5.30488Z"
				stroke="#8B8B8B"
			/>
			<path d="M5.66797 3.66553V14.6389" stroke="#8B8B8B" />
			<path d="M10.332 0.784302V11.8674" stroke="#8B8B8B" />
		</svg>
	);
};
